module.exports = "https://cdn.hellotech.com/client-assets/tech-client-speaker-tablet_b63408b35fab91b963d753ebcc2854f3.jpg";